function changeDates(data) {
  var Alldata = "";
  const qtyObj = data.filter((item, i) => {
    if (item.name == "quantity") {
      return item;
    }
  })[0];
  const item_qty = parseInt(qtyObj.value);
  var variantid = data.filter((item, i) => {
    if (item.name == "id") {
      return item;
    }
  })[0].value;
  var dom = $("#dalivery_data_variant_id" + variantid);
  const alldates = $("#delivery-dates").val().split(",");
  var dataval = $(dom).data("values") || false;
  console.log(dataval, "datavaldatavaldatavaldataval");
  if (dataval) {
    var propotionsval = $(dom).data("propotions") || false;

    let cartKitStockes =
      localStorage.getItem("cart-kit-stockes") != undefined
        ? JSON.parse(localStorage.getItem("cart-kit-stockes"))
        : {};
    cartKitStockes[variantid] = dataval;

    // console.log(cartKitStockes, 'cartKitStockes');

    localStorage.setItem("cart-kit-stockes", JSON.stringify(cartKitStockes));
    let proportions =
      localStorage.getItem("proportions") != undefined
        ? JSON.parse(localStorage.getItem("proportions"))
        : {};
    proportions[variantid] = propotionsval;
    console.log(proportions, "proportions", proportions[variantid]);

    localStorage.setItem("proportions", JSON.stringify(proportions));
    Alldata = kitProductDateProp(item_qty, dataval, propotionsval);
    data.map((item, i) => {
      if (item.name == "properties[Approximate Delivery Date]") {
        item.value = Alldata;
      }
      return item;
    });
    return data;
  } else {
    var stocks = [];
    stocks[0] = parseInt(dom.data("inventory")) || 0;
    stocks[1] = parseInt(dom.data("stock30")) || 0;
    stocks[2] = parseInt(dom.data("stock60")) || 0;
    stocks[3] = parseInt(dom.data("stock90")) || 0;
    var stocksString = stocks.join(",");
    let cartStockes =
      localStorage.getItem("cart-stockes") != undefined
        ? JSON.parse(localStorage.getItem("cart-stockes"))
        : {};
    cartStockes[variantid] = stocksString;
    localStorage.setItem("cart-stockes", JSON.stringify(cartStockes));
    if (stocks.length > 0) {
      var properties = {};
      let remaining = item_qty;
      var allStocks0 = 0;
      const varaiantStockSum = stocks.reduce(
        (a, b) => parseInt(a) + parseInt(b),
        0,
      );
      let firstnonzeroindex = 0;
      for (var i = 0; i < stocks.length; i++) {
        if (stocks[i] > 0) {
          firstnonzeroindex = i;
          break;
        }
      }
      if (item_qty <= stocks[firstnonzeroindex] && varaiantStockSum != 0) {
        Alldata = `   ${alldates[firstnonzeroindex]}  (Qty ${item_qty}),`;
      } else {
        for (var i = 0; i < stocks.length; i++) {
          const stock = parseInt(stocks[i]);
          if (i == firstnonzeroindex && stock > 0) {
            Alldata += ` ${alldates[firstnonzeroindex]} (Qty ${stock}), `;
            remaining = remaining - stock;
          } else if (
            i != firstnonzeroindex &&
            stock > 0 &&
            remaining > 0 &&
            stock < remaining
          ) {
            remaining = remaining - stock;
            Alldata += ` ${alldates[i]} (Qty ${stock}), `;
          } else if (
            i != firstnonzeroindex &&
            stock > 0 &&
            remaining > 0 &&
            stock >= remaining
          ) {
            Alldata += `${alldates[i]} (Qty ${remaining}), `;
            remaining = remaining - stock;
          }
          if (remaining > 0 && i == 3) {
            Alldata += `${alldates[4]} (Qty ${remaining}), `;
          }
        }
      }
      if (varaiantStockSum == 0) {
        Alldata = ` ${alldates[4]} (Qty ${remaining}),`;
      }
      Alldata = Alldata.replace(/,\s*$/, "");
      data.map((item, i) => {
        if (item.name == "properties[Approximate Delivery Date]") {
          item.value = Alldata;
        }
        return item;
      });
      return data;
    } else {
      return data;
    }
  }
}
function changeProps(variant_id, qty) {
  const alldates = $("#delivery-dates").val().split(",");
  let cartStockes =
    localStorage.getItem("cart-stockes") != undefined
      ? JSON.parse(localStorage.getItem("cart-stockes"))
      : false;
  let cartKitStockes =
    localStorage.getItem("cart-kit-stockes") != undefined
      ? JSON.parse(localStorage.getItem("cart-kit-stockes"))
      : false;
  let porportions =
    localStorage.getItem("proportions") != undefined
      ? JSON.parse(localStorage.getItem("proportions"))
      : false;
  variant_id = variant_id.split(":")[0];
  if (cartKitStockes[variant_id] != undefined) {
    var dataval = cartKitStockes[variant_id];
    var porportionsval = porportions[variant_id];
    Alldata = kitProductDateProp(qty, dataval, porportionsval);
    properties = {
      "Approximate Delivery Date": Alldata,
    };
    return properties;
  } else if (cartStockes[variant_id] != undefined) {
    var stocks = cartStockes[variant_id].split(",");
    const item_qty = parseInt(qty);
    var properties = {};
    let remaining = item_qty;
    var Alldata = "";
    var allStocks0 = 0;
    const varaiantStockSum = stocks.reduce(
      (a, b) => parseInt(a) + parseInt(b),
      0,
    );
    let firstnonzeroindex = 0;
    for (var i = 0; i < stocks.length; i++) {
      if (stocks[i] > 0) {
        firstnonzeroindex = i;
        break;
      }
    }
    if (item_qty <= stocks[firstnonzeroindex] && varaiantStockSum != 0) {
      Alldata = ` ${alldates[firstnonzeroindex]} (Qty ${item_qty}),`;
    } else {
      for (var i = 0; i < stocks.length; i++) {
        const stock = parseInt(stocks[i]);
        if (i == firstnonzeroindex && stock > 0) {
          Alldata += ` ${alldates[firstnonzeroindex]} (Qty  ${stock}), `;
          remaining = remaining - stock;
        } else if (
          i != firstnonzeroindex &&
          stock > 0 &&
          remaining > 0 &&
          stock < remaining
        ) {
          remaining = remaining - stock;
          Alldata += ` ${alldates[i]} (Qty ${stock}), `;
        } else if (
          i != firstnonzeroindex &&
          stock > 0 &&
          remaining > 0 &&
          stock >= remaining
        ) {
          Alldata += `${alldates[i]} (Qty  ${remaining}), `;
          remaining = remaining - stock;
        }
        if (remaining > 0 && i == 3) {
          Alldata += `${alldates[4]} (Qty ${remaining}), `;
        }
      }
    }
    if (varaiantStockSum == 0) {
      Alldata = ` ${alldates[4]} (Qty ${item_qty}),`;
    }
    Alldata = Alldata.replace(/,\s*$/, "");
    properties = {
      "Approximate Delivery Date": Alldata,
    };
    return properties;
  } else {
    return false;
  }
}

function copykitdelivery_date(startd = 0, endd = 0, variantid, productId) {
  if (Shopify.locale != "fr") {
    var months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
  } else {
    var months = [
      "Jan",
      "Fév",
      "Mar",
      "Avr",
      "Mai",
      "Jun",
      "Jui",
      "Aout",
      "Sep",
      "Oct",
      "Nov",
      "Déc",
    ];
  }

  let nth = function (d) {
    if (d > 3 && d < 21) return "th";
    switch (d % 10) {
      case 1:
        return "st";
      case 2:
        return "nd";
      case 3:
        return "rd";
      default:
        return "th";
    }
  };

  function get_date(d, days) {
    return new Date(d.getTime() + days * 24 * 60 * 60 * 1e3);
  }
  var cdate = get_date(new Date(), startd + 5);
  var cdate_el = $(
    '.meta_deliver[data-variant-id="' + variantid + '"] .prod_current_date',
  );
  var ndate_el = $(
    '.meta_deliver[data-variant-id="' + variantid + '"] .prod_next_date',
  );

  cdate_el.text(cdate.getDate() + " " + months[cdate.getMonth()]);
  var ndate = get_date(new Date(), endd + 10);
  ndate_el.text(ndate.getDate() + " " + months[ndate.getMonth()]);
  console.log(cdate, ndate);
}

function singleKitdelivery_date(startd = 0, endd = 0, productid) {
  if (Shopify.locale != "fr") {
    var months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
  } else {
    var months = [
      "Jan",
      "Fév",
      "Mar",
      "Avr",
      "Mai",
      "Jun",
      "Jui",
      "Aout",
      "Sep",
      "Oct",
      "Nov",
      "Déc",
    ];
  }

  let nth = function (d) {
    if (d > 3 && d < 21) return "th";
    switch (d % 10) {
      case 1:
        return "st";
      case 2:
        return "nd";
      case 3:
        return "rd";
      default:
        return "th";
    }
  };

  function get_date(d, days) {
    return new Date(d.getTime() + days * 24 * 60 * 60 * 1e3);
  }
  var cdate = get_date(new Date(), startd + 5);
  // var cdate_el = $('.meta_deliver[data-variant-id="' + variantid + '"] .prod_current_date');
  //var ndate_el = $('.meta_deliver[data-variant-id="' + variantid + '"] .prod_next_date');

  var cdate_el = $(
    '.meta_deliver[data-product-id="' + productid + '"] .prod_current_date',
  );
  var ndate_el = $(
    '.meta_deliver[data-product-id="' + productid + '"] .prod_next_date',
  );

  cdate_el.text(cdate.getDate() + " " + months[cdate.getMonth()]);
  var ndate = get_date(new Date(), endd + 10);
  ndate_el.text(ndate.getDate() + " " + months[ndate.getMonth()]);
  console.log(cdate, ndate);
}

function kitProductDateProp(newqunatity = 0, data, proportions) {
  var final = [];
  console.log(newqunatity, "newqunatity");
  for (let i = 1; i <= newqunatity; i++) {
    final[i - 1] = kitcalculateDate(i, data, proportions);
  }
  console.log(final);
  const occurrences = final.reduce(function (acc, curr) {
    return (acc[curr] ? ++acc[curr] : (acc[curr] = 1), acc);
  }, {});
  const sortObject = (o) =>
    Object.keys(o)
      .sort()
      .reduce((r, k) => ((r[k] = o[k]), r), {});
  var obj = sortObject(occurrences);
  var Alldata = "";
  const alldates = $("#delivery-dates").val().split(",");
  for (let i = 0; i < Object.keys(obj).length; i++) {
    let value = Object.values(obj)[i];
    let key = Object.keys(obj)[i];
    Alldata += ` ${alldates[key]} (Qty  ${value}), `;
  }
  Alldata = Alldata.replace(/,\s*$/, "");
  return Alldata;
}

function copyKitProductDateProp(newqunatity = 0, data, proportions) {
  var final = [];
  console.log(newqunatity, "newqunatity");
  for (let i = 1; i <= newqunatity; i++) {
    final[i - 1] = kitcalculateDate(i, data, proportions);
  }
  console.log(final);
  const occurrences = final.reduce(function (acc, curr) {
    return (acc[curr] ? ++acc[curr] : (acc[curr] = 1), acc);
  }, {});
  const sortObject = (o) =>
    Object.keys(o)
      .sort()
      .reduce((r, k) => ((r[k] = o[k]), r), {});
  var obj = sortObject(occurrences);
  var Alldata = "";
  const alldates = $("#delivery-dates").val().split(",");
  for (let i = 0; i < Object.keys(obj).length; i++) {
    let value = Object.values(obj)[i];
    let key = Object.keys(obj)[i];
    Alldata += ` ${alldates[key]}, `;
  }
  Alldata = Alldata.replace(/,\s*$/, "");
  return Alldata;
}

function kitDeliverStock(stock, multqnt, index1) {
  var nstock = parseInt(stock[0] - multqnt);
  if (nstock >= 0) {
    return 0;
  }
  if (nstock < 0 && stock[1] != 0) {
    let cstock = parseInt(parseInt(stock[1]) + parseInt(stock[0]));
    nstock = parseInt(cstock - multqnt);
  }
  if (nstock >= 0) {
    console.log(nstock, multqnt, stock, "bbb1");
    return 1;
  }
  if (nstock < 0 && stock[2] != 0) {
    let cstock = parseInt(
      parseInt(stock[0]) + parseInt(stock[1]) + parseInt(stock[2]),
    );
    nstock = parseInt(cstock - multqnt);
  }
  if (nstock >= 0) {
    return 2;
  }
  if (nstock < 0 && stock[3] != 0) {
    let cstock = parseInt(
      parseInt(stock[0]) +
      parseInt(stock[1]) +
      parseInt(stock[2]) +
      parseInt(stock[3])
    );
    nstock = parseInt(cstock - multqnt);
  }

  if (nstock >= 0) {
    return 3;
  }

  return 4;
}

function kitcalculateDate(newqunatity = 0, data, propotions) {
  var stocks = [];
  var var_id = $(".product-single__variants").val();
  propotions = String(propotions);
  propotions = propotions.split(",");
  var quantity = newqunatity;
  data = data.split(",");
  data.map((item, index) => {
    var n = String(item.split("@")[1]);
    var nn = n.split("$");
    stocks[index] = nn;
  });
  var final = 0;

  for (let index1 = 0; index1 < stocks.length; index1++) {
    var mult = parseInt(quantity * propotions[index1]);
    var newstockinfo = kitDeliverStock(stocks[index1], mult, index1);
    if (final < newstockinfo) {
      final = newstockinfo;
    }
  }

  return final;
}

function copykitcalculateDate(newqunatity = 0, data, propotions) {
  var stocks = [];
  var var_id = $(".product-single__variants").val();
  propotions = String(propotions);
  propotions = propotions.split(",");
  var quantity = newqunatity;
  data = data.split(",");
  data.map((item, index) => {
    var n = String(item.split("@")[1]);
    var nn = n.split("$");
    stocks[index] = nn;
  });
  var final = 0;

  for (let index1 = 0; index1 < stocks.length; index1++) {
    var mult = parseInt(quantity * propotions[index1]);
    var newstockinfo = kitDeliverStock(stocks[index1], mult, index1);
    if (final < newstockinfo) {
      final = newstockinfo;
    }
  }

  return final;
}

function kitDateCalculate() {
  var var_id = $(".product-single__variants").val();
  var newqunatity = parseInt($(".quann input").val());
  var data = $("#dalivery_data_variant_id" + var_id).data("values");
  var propotions = $("#dalivery_data_variant_id" + var_id).data("propotions");
  var text = kitProductDateProp(newqunatity, data, propotions);
  var final = kitcalculateDate(newqunatity, data, propotions);
  //console.log(final, 'finalfinalfinalfinal');
  var stockseval = [0, 25, 60, 90, 120];
  //
  // kitdelivery_date(stockseval[final], stockseval[final]);
  console.log('!!!!4');
  kitdelivery_date();
}

function parseMDY(s) {
  if (!s) return null;
  const m = String(s)
    .trim()
    .match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/);
  if (!m) return null;
  const mm = parseInt(m[1], 10) - 1;
  const dd = parseInt(m[2], 10);
  const yy = parseInt(m[3], 10);
  const d = new Date(yy, mm, dd);
  return isNaN(d.getTime()) ? null : d;
}

function addDays(date, days) {
  const d = new Date(date);
  d.setDate(d.getDate() + days);
  return d;
}

function monthsByLocale() {
  return Shopify.locale !== "fr"
    ? [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ]
    : [
      "Jan",
      "Fév",
      "Mar",
      "Avr",
      "Mai",
      "Jun",
      "Jui",
      "Aout",
      "Sep",
      "Oct",
      "Nov",
      "Déc",
    ];
}

function fmt(d) {
  const months = monthsByLocale();
  return months[d.getMonth()] + " " + d.getDate();
}

function kitdelivery_date(variantId, container = document) {
  // Find variantID
  const el = container.querySelector('[id^="DeliveryVariantJson-"]');

  if (!el) return;
  const variantData = JSON.parse(el.innerHTML);
  const variant = (variantData.variants || []).find(
    (v) => String(v.id) === String(variantId),
  );

  const $wrap = $(".meta_deliver").first();
  if (!$wrap.length) return;

  // update qty and expected delivery
  parseInt($wrap.attr("data-inventory-qty", variant.inventory_quantity || "0"));
  $wrap.attr("data-expected-delivery", variant.expected_delivery);

  // calculate dates

  const $cur = $(container.querySelector(".current_date"));
  const $nxt = $(container.querySelector(".next_date"));

  if (!$cur.length || !$nxt.length) return;

  const inventory = parseInt($wrap.attr("data-inventory-qty") || "0", 10);
  const expectedRaw = ($wrap.attr("data-expected-delivery") || "")
    .toString()
    .trim();
  const expectedDate = parseMDY(expectedRaw);

  let baseDate, fromDays, toDays;

  if (inventory > 0) {
    baseDate = new Date();
    fromDays = 5;
    toDays = 10;
  } else if (expectedDate) {
    baseDate = expectedDate;
    fromDays = 5;
    toDays = 10;
  } else {
    baseDate = new Date();
    fromDays = 125;
    toDays = 130;
  }

  const fromDate = addDays(baseDate, fromDays);
  const toDate = addDays(baseDate, toDays);

  $cur.text(fmt(fromDate));
  $nxt.text(fmt(toDate));
}

window.addEventListener("delivery:update", ({ detail: { container, variantID } }) => {
  kitdelivery_date(variantID, container);
});

$(document).ready(function () {
  // setTimeout(kitDateCalculate, 3000);
  // setTimeout(kitdelivery_date, 100);

  var mysecs = $(".sectionals_product").length;
  if (mysecs > 0) {
    $(".sectionals_product").each(function () {
      var values = $(this).data("values");
      var propotions = $(this).data("propotions");
      var productId = $(this).data("product-id");
      var variantId = $(this).data("variant-id");

      if (values != undefined) {
        console.log(values, propotions, productId, variantId);
        var text = copyKitProductDateProp(1, values, propotions);
        var final = copykitcalculateDate(1, values, propotions);
        var stockseval = [0, 25, 60, 90, 120];
        copykitdelivery_date(
          stockseval[final],
          stockseval[final],
          variantId,
          productId,
        );
        if (
          window.location.href.indexOf("living-stock") > -1 &&
          stockseval[final] > 0
        ) {
          $("#sectionals_product" + variantId).remove();
        }
      } else {
        var ivn = $(this).data("inventory-qty");
        if (window.location.href.indexOf("living-stock") > -1 && ivn == 0) {
          $("#sectionals_product" + variantId).remove();
        }
      }
    });

    $(".single_product_meta").each(function () {
      var productId = $(this).data("product-id");
      var variantId = $(this).data("variant-id");
      var inventory = $(this).data("inventory-qty");
      var stock30 = $(this).data("stock30");
      var stock90 = $(this).data("stock90");
      var stock60 = $(this).data("stock60");

      var indexVal = 0;
      if (inventory > 0) {
        indexVal = 0;
      } else if (stock30 > 0) {
        indexVal = 25;
      } else if (stock60 > 0) {
        indexVal = 60;
      } else if (stock90 > 0) {
        indexVal = 90;
      } else {
        indexVal = 120;
      }

      singleKitdelivery_date(indexVal, indexVal, productId);
    });
  }

  // var var_id =$('.product-single__variants').val();
  // var data = $('#dalivery_data_variant_id'+var_id).data('values') || false;
  //    if(data){
  //      $('.quann input').on('change',(e)=>{ kitDateCalculate(); });
  //      $('.variant-input').on('click', function() { kitDateCalculate(); });
  //      $('.js-qty__adjust.js-qty__adjust--plus').click(()=>{kitDateCalculate(1);});
  //      $('.js-qty__adjust.js-qty__adjust--minus').click(()=>{ kitDateCalculate(-1);});
  //    }
});
